import { render, staticRenderFns } from "./HotAct.vue?vue&type=template&id=5fde8d33&scoped=true&"
import script from "./HotAct.vue?vue&type=script&lang=js&"
export * from "./HotAct.vue?vue&type=script&lang=js&"
import style0 from "./HotAct.vue?vue&type=style&index=0&id=5fde8d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde8d33",
  null
  
)

export default component.exports